module.exports = __webpack_public_path__ + "media/ets/ets-telco-white-0b44fe82.png";